import axios from "../../axios-config";

export const ARTIST_MANAGER_ACTIVITY_TYPES = {
  CREATE_FIRST_BIO_LINK: "create_first_bio_link",
  CREATE_FIRST_PRESAVE_LINK: "create_first_presave_link",
  CREATE_AND_COMPLETE_TEN_TASKS: "create_and_complete_ten_tasks",
  LOG_TEN_EXPENSES: "log_ten_expenses",
  SETUP_FIRST_FUTURE_SAVE: "setup_first_future_save",
  LOG_THIRTY_EXPENSES: "log_thirty_expenses",
  CREATE_TEN_MUSIC_LINKS: "create_ten_music_links",
  BOOK_YOUR_SESSION: "book_your_session",
};

/**
 * Track a single Artist Manager activity event.
 * The backend aggregates these events into reward progress and returns
 * any newly reached milestones (completed rewards) in `milestonesReached`.
 *
 * @param {string} activityType - one of ARTIST_MANAGER_ACTIVITY_TYPES
 * @param {object} metadata - context such as linkId, taskId, expenseId, etc.
 */
export const trackArtistManagerActivity = async (activityType, metadata = {}) => {
  const response = await axios.post("/user/v1/activity/track", {
    activityType,
    metadata,
  });
  return response?.data?.data || { isFirstVisit: false, visitCount: 0, milestonesReached: [] };
};
